import { useEffect, useCallback } from 'react';

const ADOBE_DATA_LAYER = 'adobeDataLayer';
const eventTitles = {
    CART_ADDITION: 'Cart addition',
    CLICK: 'Click Event Product',
    SPONSORED_IMPRESSION: 'Sponsored Product Impression',
};
const interactionNames = {
    CART_ADDITION: 'Cart addition Zootopia',
    CLICK: 'Zootopia tracking / click',
    SPONSORED_IMPRESSION: 'Zootopia Sponsored Impression',
};
const interactionTypes = {
    CLICK: 'Click',
    IMPRESSION: 'Impression',
};
const useAdobeUtils = () => {
    const ensureAdobeDataLayer = function () {
        if (!window.hasOwnProperty(ADOBE_DATA_LAYER)) {
            window[ADOBE_DATA_LAYER] = [];
        }
    };
    useEffect(() => {
        ensureAdobeDataLayer();
    }, []);
    const trackRecommendationClickEvent = (recommendation) => {
        trackClickEvent(eventTitles.CLICK, interactionNames.CLICK, {
            articleId: recommendation.getArticleId(),
            shopIdentifier: recommendation.getProductShopIdentifier(),
            variantID: recommendation.getVariantId(),
            targetLink: window.location.origin + recommendation.getLink(),
        });
    };
    const trackAddRecommendationEvent = (recommendation) => {
        const priceFields = recommendation.getPriceFields();
        trackClickEvent(eventTitles.CART_ADDITION, interactionNames.CART_ADDITION, {
            articleId: recommendation.getArticleId(),
            shopIdentifier: recommendation.getProductShopIdentifier(),
            variantID: recommendation.getVariantId(),
            quantity: 1,
            unitPrice: priceFields.currentPriceValue,
            total: priceFields.currentPriceValue,
            currencyCode: priceFields.currency,
            positionInCart: 1,
            sellerType: priceFields.offerType,
            targetLink: window.location.origin + recommendation.getLink(),
        });
    };
    const trackClickEvent = useCallback((title, name, details) => {
        sendAdobeEvent({
            event: title,
            interaction: {
                type: interactionTypes.CLICK,
                name: name,
                details: details,
            },
        });
    }, []);
    const trackSponsoredImpressionEvent = useCallback((recommendations) => {
        sendAdobeEvent({
            event: eventTitles.SPONSORED_IMPRESSION,
            interaction: {
                type: interactionTypes.IMPRESSION,
                name: interactionNames.SPONSORED_IMPRESSION,
                details: {
                    articles: recommendations.map((rec) => ({
                        articleId: rec.getArticleId(),
                        shopIdentifier: rec.getProductShopIdentifier(),
                        variantId: rec.getVariantId(),
                        targetLink: window.location.origin + rec.getLink(),
                    })),
                },
            },
        });
    }, []);
    const sendAdobeEvent = (event) => {
        ensureAdobeDataLayer();
        window[ADOBE_DATA_LAYER].push(event);
    };
    return {
        trackClickEvent,
        trackRecommendationClickEvent,
        trackAddRecommendationEvent,
        trackSponsoredImpressionEvent,
    };
};

export { useAdobeUtils as default };
//# sourceMappingURL=use-adobe-utils.js.map
